// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class AttributeResource extends Resource {
    basePath: string = 'attributes/attributes/{object_type}/{object_id}/';

    _getBasePath = (objectType: string, objectId: string) => this.basePath.replace('{object_type}', objectType)
        .replace('{object_id}', objectId);

    schema(objectType: string, objectId: string): Promise<Object> {
        return this.client._request(this._getBasePath(objectType, objectId), 'OPTIONS')
            .then((response) => response.data);
    }

    get(objectType: string, objectId: string, query: Object): Promise<Object> {
        return this.client._request(this._getBasePath(objectType, objectId), 'GET', query)
            .then((response) => response.data);
    }

    update(objectType: string, objectId: string, data: Object): Promise<Object> {
        return this.client._request(this._getBasePath(objectType, objectId), 'PUT', data)
            .then((response) => response.data);
    }
}
